import { Accordion, Typography } from '@smartgift/frontend-toolkit';
import React, { useMemo, useRef, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Notification } from '@hero/atoms';
import { ShowMore } from '@hero/molecules';
import { getSafeInnerHtml } from '@hero/utils';

import { ProductDetailImage } from './ProductDetailImage';
import { ProductDetailInfo } from './ProductDetailInfo';
import { ProductOptionsByTable } from './ProductOptionsByTable';
import { SkuSelectionTable } from './SkuSelectionTable';
import * as S from './style';

export default function ProductDetailByTable({
  product,
  selectedSkus,
  setSelectedSkus,
  someSkusUnavailable
}) {
  const { t } = useTranslation();

  const accordionTitleRef = useRef();
  const [swiperRef, setSwiperRef] = useState();

  const images = useMemo(() => {
    if (!product?.orderable) {
      return product?.images;
    }

    return [...(product?.images || [])].concat(
      product.skus.reduce((total, sku) => {
        const selected = selectedSkus?.find(s => s.sku === sku.code);

        return [...total, ...(sku?.images?.map(i => ({ ...i, selected })) || [])];
      }, [])
    );
  }, [product?.orderable, product?.skus, selectedSkus]);

  return (
    <S.ProductDetailGeneralWrapper>
      {someSkusUnavailable && product?.orderable && (
        <Notification
          status="warning"
          isClosable
          message={
            <Typography variant="body2">
              <Trans i18nKey="someVariantsUnavailable" components={{ b: <b /> }} />
            </Typography>
          }
        />
      )}
      <S.ProductDetailWrapper>
        <S.ProductDetailImageArea>
          <ProductDetailImage product={product} images={images} setSwiperRef={setSwiperRef} />
        </S.ProductDetailImageArea>
        <S.ProductDetail>
          <ProductDetailInfo product={product} />

          <S.ProductDesc>
            <ShowMore numberOfLines={1}>
              <div {...getSafeInnerHtml(product.desc || '')} />
            </ShowMore>
          </S.ProductDesc>

          {product?.orderable ? (
            <ProductOptionsByTable product={product} accordionTitleRef={accordionTitleRef} />
          ) : (
            <S.ProductDetailNotification>
              <Notification
                status="warning"
                isClosable
                message={
                  <Typography variant="body2">
                    <Trans i18nKey="allVariantsUnavailable" />
                  </Typography>
                }
              />
            </S.ProductDetailNotification>
          )}
        </S.ProductDetail>
      </S.ProductDetailWrapper>

      <S.ConfigureAccordion>
        <Accordion
          title={t('configureWhatRecipientsCanSelect')}
          description={t('configureWhatRecipientsCanSelectDesc')}
          headerRef={accordionTitleRef}
          variant="outlined"
        >
          <SkuSelectionTable
            product={product}
            selectedSkus={selectedSkus}
            setSelectedSkus={setSelectedSkus}
            swiperRef={swiperRef}
          />
        </Accordion>
      </S.ConfigureAccordion>
    </S.ProductDetailGeneralWrapper>
  );
}
